import script from "./SkillsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsPage.vue?vue&type=script&setup=true&lang=js"

import "./SkillsPage.vue?vue&type=style&index=0&id=13f94c01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13f94c01"]])

export default __exports__